import * as React from "react";
import {useEffect} from "react";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {Button, Checkbox, Dropdown, Popup} from "semantic-ui-react";
import {createCustomerReport, CustomerReportFilter} from "../../../context/CustomerReport";
import {
    customerReport,
    customerReportSummary,
    fetchCustomerReport,
    originalCustomerReportResponse
} from "../../../../style/page_with_sidebar";
import {ConfigContext} from "../../../context/ConfigContext";
import {createCustomerReportSummary} from "./CustomerReportPopup";


export interface CustomerReportFilterSettingsProps {

}

export function CustomerReportFilterSettings(props: React.PropsWithChildren<CustomerReportFilterSettingsProps>) {

    const context = React.useContext(ConfigContext)

    const [responsibleManagers, setResponsibleManagers] = React.useState<string[]>([]);
    const [availableResponsibleManagers, setAvailableResponsibleManagers] = React.useState<string[]>([]);
    const [addCompaniesWithoutResponsibleManager, setAddCompaniesWithoutResponsibleManager] = React.useState<boolean | null>(null);

    useEffect(() => {

        let storedFilter = JSON.parse(localStorage.getItem("customerReportFilter")) as CustomerReportFilter
        if(!storedFilter) {
            storedFilter = {
                responsibleManagers: [],
                addCompaniesWithoutResponsibleManager: true
            } as CustomerReportFilter
            localStorage.setItem("customerReportFilter", JSON.stringify(storedFilter))
        }
        const storedResponsibleManagers = storedFilter.responsibleManagers || [];
        setResponsibleManagers(storedResponsibleManagers);
        setAddCompaniesWithoutResponsibleManager(storedFilter.addCompaniesWithoutResponsibleManager || true)

        fetchResponsibleManagers().then(r => {
            console.log("Responsible managers fetched: ", r);
            const merged = [...new Set([...r, ...storedResponsibleManagers])].filter((item) => {
                return item != null && item != ""
            });
            setAvailableResponsibleManagers(merged);
        })
    }, []);

    useEffect(() => {
        // Save filter to local storage
        let newFilter = {
            responsibleManagers: responsibleManagers,
            addCompaniesWithoutResponsibleManager: addCompaniesWithoutResponsibleManager
        } as CustomerReportFilter
        localStorage.setItem("customerReportFilter", JSON.stringify(newFilter))

        if (originalCustomerReportResponse.value) {
            let currentReport = createCustomerReport(originalCustomerReportResponse.value)
            customerReport.value = currentReport
            customerReportSummary.value = createCustomerReportSummary(currentReport)
        } else {
            fetchCustomerReport(context, true).then(r => {});
        }
    }, [responsibleManagers, addCompaniesWithoutResponsibleManager])

    return <div>
        <h1>CustomerReportFilter</h1>
        <Dropdown
            multiple
            selection
            options={availableResponsibleManagers.map((item) => {
                return {
                    key: item,
                    text: item,
                    value: item
                }
            })}
            value={responsibleManagers}
            onChange={(e, data) => {
                setResponsibleManagers(data.value as string[])
            }}
            placeholder='Select responsible managers'
            search
            closeOnBlur
            closeOnChange={false}
            style={{
                flex: 1,
                width: "500px",
            }}
        />
        <Popup
            trigger={
                <Button
                    icon='user'
                    onClick={() => {
                        let me = authentication.user.email
                        if (me) {
                            setResponsibleManagers([me])
                            setAvailableResponsibleManagers(prev => {
                                if (!prev.includes(me)) {
                                    return [...prev, me]
                                }
                                return prev
                            })
                        }
                    }}
                    style={{
                        marginLeft: "10px",
                        marginTop: "10px"
                    }}
                />
            }
            content='Set responsible manager to me'
            position='top center'
            inverted
        />
        <Checkbox
            toggle
            label='Add companies without responsible manager'
            checked={addCompaniesWithoutResponsibleManager == true}
            onChange={(e, data) => {
                setAddCompaniesWithoutResponsibleManager(data.checked)
            }}
        />
    </div>
}

export async function fetchResponsibleManagers() {
    let auth = backend.withTokenAuthHeader(authentication.token)
    let response = await backend.internalApi.fetchAllResponsibleManagers(auth)
    let r = response.companyWithResponsibleManager?.map((item) => {
        return item.responsibleManager
    })
    // unique and filter out null/empty
    return [...new Set(r)].filter((item) => {
        return item != null && item != ""
    });
}